import { useTheme } from "@/context/ThemeContext";

const steps = [
  {
    number: "01",
    title: "Audit",
    desc: "Identify revenue leaks and gaps in your current process.",
    icon: "ri-search-eye-line",
    img: "https://public.readdy.ai/ai/img_res/c8df69fc8032467b3a0c536bae678a86.jpg",
  },
  {
    number: "02",
    title: "Design",
    desc: "Map your ideal system architecture and automation flows.",
    icon: "ri-draft-line",
    img: "https://readdy.ai/api/search-image?query=system%20design%20blueprint%20architecture%20diagram%20whiteboard%20planning%20minimal%20clean%20professional%20workspace%20neutral%20tones%20premium%20photography&width=500&height=320&seq=process-design-002&orientation=landscape",
  },
  {
    number: "03",
    title: "Build",
    desc: "Deploy the full automation infrastructure end-to-end.",
    icon: "ri-tools-line",
    img: "https://readdy.ai/api/search-image?query=technology%20deployment%20infrastructure%20building%20automation%20systems%20server%20digital%20construction%20minimal%20clean%20dark%20background%20premium%20photography&width=500&height=320&seq=process-build-003&orientation=landscape",
  },
  {
    number: "04",
    title: "Optimize",
    desc: "Continuously improve performance based on real data.",
    icon: "ri-line-chart-line",
    img: "https://readdy.ai/api/search-image?query=performance%20optimization%20data%20analytics%20growth%20charts%20upward%20trend%20minimal%20clean%20professional%20dashboard%20premium%20photography%20neutral%20background&width=500&height=320&seq=process-optimize-004&orientation=landscape",
  },
];

export default function ProcessSection() {
  const { theme } = useTheme();
  const isDark = theme === "dark";

  return (
    <section className={`py-32 md:py-44 transition-colors duration-300 ${isDark ? "bg-[#111111]" : "bg-[#f5f5f7]"}`}>
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="text-center mb-20">
          <p className={`text-[11px] tracking-[0.15em] uppercase font-semibold mb-5 ${isDark ? "text-white/35" : "text-[#6e6e73]"}`}>How It Works</p>
          <h2 className={`text-4xl md:text-5xl font-black tracking-[-0.02em] ${isDark ? "text-white" : "text-[#1d1d1f]"}`}>Our Process</h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {steps.map((step) => (
            <div
              key={step.number}
              className={`rounded-2xl overflow-hidden transition-all duration-300 hover:-translate-y-1 ${
                isDark ? "bg-[#1c1c1e] border border-white/6" : "bg-white border border-black/5"
              }`}
            >
              {/* Image */}
              <div className="w-full h-40 overflow-hidden">
                <img
                  src={step.img}
                  alt={step.title}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              {/* Content */}
              <div className="p-6">
                <div className="flex items-center justify-between mb-4">
                  <div className={`w-9 h-9 flex items-center justify-center rounded-xl ${isDark ? "bg-white/8" : "bg-[#f5f5f7]"}`}>
                    <i className={`${step.icon} text-base ${isDark ? "text-white/70" : "text-[#1d1d1f]/70"}`}></i>
                  </div>
                  <span className={`text-xs font-black tracking-widest ${isDark ? "text-white/20" : "text-[#1d1d1f]/20"}`}>{step.number}</span>
                </div>
                <h3 className={`font-black text-xl mb-2 ${isDark ? "text-white" : "text-[#1d1d1f]"}`}>{step.title}</h3>
                <p className={`text-sm leading-relaxed ${isDark ? "text-white/40" : "text-[#6e6e73]"}`}>{step.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
